import type { QuestionWithSlide } from '@mentimeter/presentation-schema/api-types-overrides';
import type { Layout } from '@mentimeter/http-clients';

type SlideType = QuestionWithSlide['slide_type'];
type QuestionType = QuestionWithSlide['type'];

const isSlideType = (
  questionType: QuestionType,
  questionSlideType: SlideType,
  targetSlideType: SlideType,
) => questionType && questionSlideType === targetSlideType;

const isDocumentSlide = (
  questionType: QuestionType,
  questionSlideType: SlideType,
) => isSlideType(questionType, questionSlideType, 'document');

const isFullSizeImageSlide = (
  questionType: QuestionType,
  questionSlideType: SlideType,
  image_as_background: QuestionWithSlide['image_as_background'],
  slide_image_type: QuestionWithSlide['slide_image_type'],
) =>
  isSlideType(questionType, questionSlideType, 'image') &&
  (image_as_background || slide_image_type === 'image-background');

const isSideBySideLayout = (layout?: QuestionWithSlide['layout']) =>
  layout?.type === 'side-by-side' || layout?.type === 'side-by-side-right';

export const getLayoutSizeOverride = (
  layout: QuestionWithSlide['layout'],
  type: QuestionWithSlide['type'],
): Layout['size'] | '35%' | undefined => {
  // this is due to the legacy reasons
  if (isSideBySideLayout(layout)) {
    return type === 'slide' ? '50%' : '35%';
  }
  return layout?.size;
};

export const getOverrideToFullBackgroundImageWithSize = (
  questionType: QuestionType,
  questionSlideType: SlideType,
  image_as_background: QuestionWithSlide['image_as_background'],
  slide_image_type: QuestionWithSlide['slide_image_type'],
): false | 'cover' | 'contain' => {
  if (isDocumentSlide(questionType, questionSlideType)) {
    return 'contain';
  }
  if (
    isFullSizeImageSlide(
      questionType,
      questionSlideType,
      image_as_background,
      slide_image_type,
    )
  ) {
    return 'cover';
  }
  return false;
};
